var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"itemsPerPage":10,"id":"sales-table","mobile-breakpoint":"0"},on:{"pagination":_vm.onPage}})}
var staticRenderFns = []

export { render, staticRenderFns }